import { render } from "./DetallesPedido.vue?vue&type=template&id=6ab858e4&scoped=true"
import script from "./DetallesPedido.vue?vue&type=script&lang=js"
export * from "./DetallesPedido.vue?vue&type=script&lang=js"

import "./DetallesPedido.vue?vue&type=style&index=0&id=6ab858e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab858e4"]])

export default __exports__